export default {
  // 导航菜单
  nav: {
    home: "首页",
    about: "关于我们",
    product: "产品中心",
    productDetail: "产品详情",
    strength: "综合实力",
    comparison: "市场同类产品对照",
    contact: "联系我们",

    companyIntro: "公司简介",
    news: "公司动态",
    newsDetail: "新闻详情",
    honors: "企业荣誉",
    culture: "企业文化",
    recruitment: "人员招聘",

    qualityAssurance: "品质保障",
    innovation: "研发创新",
    SmartManufacturing: "智能制造",
    laboratory: "实验室",

    wechat: {
      introduction: "公司简介",
      product: "产品中心",
      productDetail: "产品详情",
      applicationResume: "应聘履历表",
    },
  },
  // 页脚
  footer: {
    copyright: "浙ICP备2026040594号",
    TechnicalSupport: "技术支持：信息部",
    company: "版权所有：乐清昌德成电子有限公司",
    logoTitle: "工业连接器解决方案专家",
    phone: "电话",
    email: "邮箱",
    address: "地址",
    fax: "传真",
    phoneNumber: "0086-0577-62351197",
    emailNumber: "sd11{'@'}hcb.com.cn",
    addressNumber: "浙江省乐清市乐清湾港区创新路4号",
    faxNumber: "0086-0577-62363197",
  },
  // 首页
  Home: {
    hero: {
      title: "连接器行业技术专家",
      subtitle:
        "乐清昌德成电子有限公司成立于1991年，是中国领先的连接器专家之一，为汽车和家电行业提供高品质的连接解决方案。",
      button: "了解更多",
    },
    products: {
      title: "产品中心",
      searchPlaceholder: "请输入产品型号或关键词",
      searchButton: "搜索",
      more: "更多 >",
      hotTag: "热门产品",
    },
    company: {
      title: "关于我们",
      content: [
        "HCB昌德成始创于1991年，专注精密连接器的研发与制造，是国家高新技术企业、国家级专精特新‘小巨人’企业、省级绿色工厂。",
        "公司产品覆盖家用电器、汽车电子、光伏储能、消费电子、工业自动化等多元应用场景，现与海尔、美的、倍科、奇瑞、长安等国内外众多知名企业达成长期合作关系。建有省级研发中心、国家级CNAS认可实验室，先后取得IATF16949、ISO9001、ISO14001、ISO45001、ISO50001等权威体系认证，具备从客户需求调研、方案定制、模具自研开发到规模化量产交付的产业链一站式配套能力。",
        "依托深厚的精密连接技术，昌德成持续赋能智慧产业与智能生活，输出高可靠性的连接器整体解决方案，致力成为全球电子连接器行业值得信赖的合作伙伴。",
      ],
      stats: {
        experience: "年行业经验",
        factory: "平方米工厂",
        employees: "专业员工",
        customers: "全球客户",
      },
    },
    industry: {
      title: "行业与应用",
      categories: ["家电行业", "汽车行业", "新能源行业", "机器人行业"],
    },
    news: {
      title: "新闻中心",
    },
  },

  // 关于我们
  About: {
    title: "关于我们",
    tabs: "工业连接器解决方案专家",
    recruitment: {
      jobCount: "共找到 {count} 条职位信息",
      contact: "0577-62521899 金经理",
      title: "在招岗位",
      content: "加入我们，共创未来",
      stats: {
        label: "在招职位",
        location: "乐清市",
        fullTime: "全职",
      },
      recruitment: "招聘",
      person: "人",
      welfare: {
        title: "薪酬福利",
        salary: {
          title: "薪资待遇",
          desc: "公司实行单休制，计件工资另算，加班费按规发放；设有全勤奖、工龄奖、岗位奖、绩效奖、质量奖、住房补贴；春节带薪休假，法定节假日全额计薪；",
        },
        insurance: {
          title: "社会保险",
          desc: "按照国家规定办理养老保险、医疗保险、失业保险、工伤保险、生育保险及住房公积金（五险一金）；",
        },
        festival: {
          title: "节日福利",
          desc: "传统节日发放节日福利及其他奖励；定期组织员工培训、户外拓展旅游、体育比赛；定期举办员工聚餐、聚会等活动；",
        },
        other: {
          title: "生活配套",
          desc: "住宿设施完善，均为双人间（含夫妻房），内有空调、热水、洗手间、网络等，拎包入住；食堂菜品丰富、干净整洁，上班期间中午免费工作餐，夜班加班发放夜餐补贴；",
        },
      },
      emptyData: {
        text: "暂无招聘职位",
        subtext: "请稍后再来查看",
      },
    },
    companyDetails: {
      title: "关于我们",
      stats: {
        experience: "年行业经验",
        factory: "平方米工厂",
        employees: "专业员工",
        customers: "全球客户",
        terminals: "亿只端子/年",
      },
      content: [
        "HCB昌德成始创于1991年，专注精密连接器的研发与制造，是国家高新技术企业、国家级专精特新‘小巨人’企业、省级绿色工厂。",
        "公司产品覆盖家用电器、汽车电子、光伏储能、消费电子、工业自动化等多元应用场景，现与海尔、美的、倍科、奇瑞、长安等国内外众多知名企业达成长期合作关系。建有省级研发中心、国家级CNAS认可实验室，先后取得IATF16949、ISO9001、ISO14001、ISO45001、ISO50001等权威体系认证，具备从客户需求调研、方案定制、模具自研开发到规模化量产交付的产业链一站式配套能力。",
        "依托深厚的精密连接技术，昌德成持续赋能智慧产业与智能生活，输出高可靠性的连接器整体解决方案，致力成为全球电子连接器行业值得信赖的合作伙伴。",
      ],
    },
    history: {
      title: "发展历程",
      items: [
        {
          year: 1991,
          title: "公司成立",
          content:
            "虹桥电瓷开关厂正式成立，迈出连接领域创业第一步，奠定企业发展根基。",
        },
        {
          year: 1993,
          title: "荣誉之路",
          content: "获得乐清市先进企业称号，开始在行业内崭露头角。",
        },
        {
          year: 1999,
          title: "品牌战略",
          content: "注册HCB品牌，开始实施品牌化战略，提升市场影响力。",
        },
        {
          year: 2001,
          title: "体系认证",
          content: "通过ISO9001质量管理体系认证，产品质量得到国际认可。",
        },
        {
          year: 2003,
          title: "扩大生产",
          content: "工厂面积扩大，引入先进生产设备，产能大幅提升。",
        },
        {
          year: 2006,
          title: "研发投入",
          content: "成立研发中心，加大技术研发投入，增强自主创新能力。",
        },
        {
          year: 2017,
          title: "战略转型",
          content: "实施自动化改造，推进智能制造，提升生产效率。",
        },
        {
          year: 2020,
          title: "高速发展",
          content: "建成数字化智能工厂，实现生产全过程的智能化管理。",
        },
        {
          year: 2025,
          title: "技术中心",
          content: "被认定为浙江省企业技术中心，技术研发能力得到官方认可。",
        },
      ],
    },
    certifications: {
      title: "资质认证",
      items: [
        {
          title: "ISO9001",
          desc: "质量管理体系认证",
        },
        {
          title: "ISO50001",
          desc: "能源管理体系认证",
        },
        {
          title: "ISO14001",
          desc: "环境管理体系认证",
        },
        {
          title: "ISO45001",
          desc: "职业健康安全管理体系认证",
        },
        {
          title: "IATF16949",
          desc: "汽车行业质量管理体系认证",
        },
      ],
    },
    partners: {
      title: "合作伙伴",
    },
    honors: {
      title: "企业荣誉",
      description: "我们公司获得了多项荣誉，彰显了我们在行业中的领先地位。",
    },
    culture: {
      values: {
        title: "核心价值观",
        items: [
          {
            title: "企业使命",
            content: "只为连接生活的美好",
          },
          {
            title: "企业愿景",
            content: "打造国际一流的电子连接器品牌",
          },
          {
            title: "核心价值观",
            content: "创新、卓越、诚信、共赢",
          },
        ],
      },
      concepts: {
        title: "经营理念",
        items: [
          {
            title: "经营方针",
            content: "凭质量起飞，靠科技腾达",
          },
          {
            title: "质量方针",
            content: "以人为本、以质取胜、持续改进、顾客满意",
          },
        ],
      },
      details: {
        title: "核心价值观详解",
        items: [
          {
            title: "创新",
            content:
              "不断探索新技术、新方法，推动产品和服务的创新，保持企业的竞争力和活力。我们鼓励员工提出新想法，勇于尝试，在创新中不断突破自我。",
          },
          {
            title: "卓越",
            content:
              "追求卓越品质，不断提升产品和服务的质量，努力做到行业领先。我们对每一个细节都精益求精，以高标准要求自己，为客户提供最优质的产品和服务。",
          },
          {
            title: "诚信",
            content:
              "诚实守信，遵守商业道德，建立良好的企业形象和品牌信誉。我们坚持言出必行，对客户、员工和合作伙伴保持诚实和透明，以诚信赢得信任。",
          },
          {
            title: "共赢",
            content:
              "与客户、员工、合作伙伴建立互利共赢的关系，共同发展。我们相信，只有通过合作与共享，才能实现可持续发展，创造更大的价值。",
          },
        ],
      },
      practice: {
        title: "企业文化实践",
        content: [
          "我们将企业文化融入到日常工作的每一个环节，通过各种活动和实践，让企业文化真正成为企业发展的动力和员工行为的准则。",
          "从产品研发到客户服务，从员工培训到团队建设，我们始终秉持核心价值观，努力创造一个积极向上、充满活力的企业氛围。",
        ],
      },
    },
  },

  // 产品中心
  Products: {
    title: "产品展示",
    banner: "工业连接器解决方案",
    filter: "筛选条件",
    productLine: "产品线",
    series: "系列",
    type: "类型",
    wireGauge: "适用线规",
    surfaceTreatment: "表面处理",
    color: "颜色",
    Spacing: "间距(mm)",
    Digits: "位数",
    NumberRows: "行数",
    clear: "清空筛选",
    product: "产品",
    pagination: {
      total: "共",
      items: "条",
      go: "前往",
      page: "页",
    },
    loading: "数据加载中...",
    NoData: "暂无数据",
    image: "产品图片",
    fields: {
      productCode: "产品编码",
      productLine: "产品线",
      series: "系列",
      specification: "规格型号",
      type: "类型",
      spacing: "间距",
      digits: "位数",
      numberRows: "行数",
      mountingDirection: "安装方向",
      wireGauge: "适用线规",
      ratedPlating: "额定电流",
      materialThickness: "材料厚度",
      insertThickness: "插片厚度",
      boltSize: "螺栓尺寸",
      color: "颜色",
      ratedVoltage: "额定电压",
      material: "材质",
      surfaceTreatment: "表面处理",
      environmentUse: "使用环境",
      competitorInfo: "同行产品信息",
      minPackageQuantity: "包装数",
      packagingType: "包装类型",
    },
    Drawing: "客户图纸 (PDF)",
    Specification: "产品规格书 (PDF)",
    search: "搜索",
    placeholder: "搜索产品...",
    searchCode: "同行料号搜索...",
    details: {
      title: "产品信息卡片",
      actionButtons: "操作按钮",
      productSpec: "产品规格书(PDF)",
      model3d: "3D模型",
      relatedProducts: "相关产品",
      supportingProducts: "所有配套产品（{count}）",
      noSupportingProducts: "暂无配套产品",
      viewProduct: "查看产品",
      pairedProducts: "配对产品（{count}）",
      noPairedProducts: "暂无配对产品",
      viewModel: "查看{title}模型",
      noPdfAvailable: "暂无PDF文档可用",
      retryLoad: "重试加载",
    },
  },

  // 综合实力
  Strength: {
    title: "综合实力",
    qualityAssurance: {
      title: "品质保证",
      description:
        "我们坚持以质量为中心，建立了完善的质量管理体系，确保每一个产品都符合高标准要求。",
      items: [
        {
          title: "质量管理体系",
          content: "通过ISO9001、IATF16949等国际认证，建立了完善的质量管理体系",
        },
        {
          title: "原材料控制",
          content: "严格的原材料采购和检验流程，确保原材料质量",
        },
        {
          title: "生产过程控制",
          content: "自动化生产设备，实时监控生产过程，确保产品一致性",
        },
        {
          title: "成品检验",
          content: "严格的成品检验流程，确保每一个产品都符合标准",
        },
        {
          title: "持续改进",
          content: "定期进行质量分析和改进，不断提升产品质量",
        },
        {
          title: "客户满意度",
          content: "定期进行客户满意度调查，不断提升服务质量",
        },
      ],
    },
    innovation: {
      title: "研发创新",
      rndTeam: {
        title: "研发团队",
        description: "我们拥有一支专业的研发团队，致力于连接器技术的创新和发展",
        orgChart: {
          title: "研发团队",
          levels: [
            [
              {
                name: "产品研发团队",
                size: "28人",
              },
              {
                name: "模具研发团队",
                size: "105人",
              },
              {
                name: "自动机研发",
                size: "5人",
              },
            ],
            [
              {
                name: "模具设计",
                size: "45人",
              },
              {
                name: "加工中心",
                size: "60人",
              },
            ],
          ],
          footer: "省级企业研发中心、温州市企业技术中心",
        },
        investment: {
          title: "研发投入",
          description:
            "始终保持高投入，确保公司在技术创新和产品研发方面保持领先地位。",
          imageAlt: "研发投入先进企业",
        },
      },
      patents: {
        title: "专利技术",
        description: "拥有多项连接器相关的专利技术，技术实力雄厚",
      },
    },
    smartManufacturing: {
      title: "智能制造",
      description:
        "我们致力于打造智能工厂，通过引进先进的智能制造技术，实现生产过程的自动化、数字化和智能化，提高生产效率和产品质量。",
      items: [
        {
          title: "AGV自动搬运",
          content:
            "采用先进的AGV（自动导引车）系统，实现物料的自动化搬运，减少人工操作，提高搬运效率和准确性。",
          imageAlt: "AGV自动搬运",
        },
        {
          title: "智能立库",
          content:
            "建立智能立体仓库，实现物料的自动化存储和检索，提高仓库空间利用率和物料管理效率。",
          imageAlt: "智能立库",
        },
        {
          title: "自动化设备",
          content:
            "引进先进的自动化生产设备，实现生产过程的自动化控制，提高生产效率和产品质量。",
          imageAlt: "自动化设备",
        },
        {
          title: "实时监控系统",
          content:
            "建立实时监控系统，对生产过程进行全程监控，及时发现和解决生产中的问题，确保产品质量。",
          imageAlt: "实时监控系统",
        },
      ],
    },
    laboratory: {
      title: "实验室",
      description: "我们拥有先进的实验室，为产品研发和质量控制提供技术支持。",
      items: [
        {
          title: "实验室设施",
          content: "拥有先进的实验室设备，为产品研发提供技术支持",
        },
        {
          title: "产品测试",
          content: "严格的产品测试流程，确保产品质量",
        },
        {
          title: "标准认证",
          content: "符合国际标准要求，产品质量有保障",
        },
        {
          title: "技术研究",
          content: "开展连接器技术研究，推动行业发展",
        },
      ],
    },
  },

  //市场同类产品对照
  ProductComparison: {
    title: "市场同类产品对照",
    searchPlaceholder: "请输入产品型号或关键词...",
    searchButton: "搜索",
    tableHeaders: {
      brand: "品牌",
      picture: "图片",
      product: "HCB同类型产品",
      description: "产品参数",
    },
  },

  // 联系我们
  Contact: {
    banner: "联系我们",
    info: "联系方式",
    form: "留言咨询",
    name: "姓名",
    email: "邮箱",
    phone: "电话",
    message: "留言内容",
    submit: "提交",
    submitting: "提交中...",
    submitSuccess: "提交成功！我们会尽快与您联系。",
    address: "浙江省乐清市乐清湾港区创新路4号",
    labels: {
      phone: "电话：",
      email: "邮箱：",
      address: "地址：",
      zip: "邮编：",
    },
    errors: {
      name: "请输入姓名",
      email: "请输入邮箱",
      emailInvalid: "请输入有效的邮箱地址",
      phone: "请输入电话",
      message: "请输入留言内容",
    },
    mapTitle: "老厂位置",
    newmapTitle: "新厂位置",
  },

  // 公司动态
  News: {
    more: "查看更多 >",
    loading: "加载中...",
    noData: "暂无新闻数据",
  },
};
